import { DependencyList, useEffect, useRef } from "react";

export const useDidUpdateEffect = (fn: () => void, deps: DependencyList | undefined) => {
    const didMountRef = useRef(false);

    useEffect(() => {
        if (didMountRef.current) fn();
        else didMountRef.current = true;
    }, deps);
};